@if (!allZeroData) {
  <div id="divChart" class="chart-container">
    <canvas id="bedAvailabilityByDay"> </canvas>
  </div>
}